import React from "react"
import { CollapsableContainer } from "@ciq/shared/components/collapsable"
import { EntrySelector } from "@ciq/shared/components/modal"
import { useLeftPaneData } from "./useLeftPaneData"
import { useAnalyticsContext } from "@ciq/shared/contexts/AnalyticsContext"

/**
 * Views module for the left panel containing metric selector.
 * Collapsible section with Metric Type dropdown.
 *
 * @returns {React.ReactElement} Views module component
 */
export function ViewsModule() {
  const { metrics, dataset } = useLeftPaneData()
  const { map } = useAnalyticsContext()

  const metricsWithTracking = {
    ...metrics,
    onChange: (selected) => {
      metrics.onChange(selected)
      map.trackMetricChanged({
        metric_id: selected.value,
        metric_name: selected.label,
        dataset: dataset.dataset.isHourly ? "hourly" : "semester",
      })
    },
  }

  return (
    <CollapsableContainer defaultOpenState={true} header="Views">
      <EntrySelector
        label="Metric Type"
        value={metricsWithTracking.current}
        options={metricsWithTracking.options}
        onChange={metricsWithTracking.onChange}
      />
    </CollapsableContainer>
  )
}
